import { Tooltip } from "@heroui/react";

const showVersion = process.env.REACT_APP_SHOW_VERSION === "true";
const version = process.env.REACT_APP_VERSION || "dev";

const AppVersionBadge = ({ expanded = true }) => {
  if (!showVersion) return null;

  const label = `v${version}`;
  const fullLabel = `Version ${version}`;
  if (!expanded) {
    return (
      <Tooltip
        content={fullLabel}
        placement="right"
        offset={12}
        className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-medium text-xs shadow-md border border-gray-100 dark:border-gray-700 px-3 py-1.5 rounded-lg"
      >
        <p
          className="mt-1 text-center text-[9px] font-medium text-gray-400"
          aria-label={`Application version ${fullLabel}`}
        >
          {label}
        </p>
      </Tooltip>
    );
  }

  return (
    <p
      className="text-center text-[10px] font-medium text-gray-400"
      aria-label={`Application version ${fullLabel}`}
    >
      {expanded ? fullLabel : label}
    </p>
  );
};

export default AppVersionBadge;
